import axios from '../util/request'
import qs from 'qs'
const md5 = require('js-md5')
const stamp = Date.now()

export const searchCreation = (data) => {
  data.stamp = stamp
  data.sign = md5(`${stamp}${data.pageNum}${data.pageSize}${atob(localStorage.getItem('okey'))}`)
  return axios.get('/interface/searchCreation', {
    params: { ...data }
  })
}

export const doAdvertiseGeneralList = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.adv_sign}${data.adv_type}${data.adv_state}${data.pageNum}${data.pageSize}${stamp}${atob(localStorage.getItem('okey'))}`)
  console.log(`${data.adv_sign}${data.adv_type}${data.adv_state}${data.pageNum}${data.pageSize}${stamp}${atob(localStorage.getItem('okey'))}`)
  return axios.get('/api/wxmp/advertise/advertiseGeneral/doAdvertiseGeneralList', {
    params: { ...data }
  })
}

export const getAdvertiseGeneralAppletAround = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.id}${data.stamp}${atob(localStorage.getItem('okey'))}`)
  return axios.get('/api/wxmp/advertise/advertiseGeneral/getAdvertiseGeneralAppletAround', {
    params: { ...data }
  })
}

export const searchCase = (data) => {
  data.stamp = stamp
  data.sign = md5(`${stamp}${data.pageNum}${data.pageSize}${atob(localStorage.getItem('okey'))}`)
  return axios.get('/interface/searchCase', {
    params: {...data}
  })
}

// 新增设计之家案例
export const addCase = (data) => {
  const key = localStorage.getItem('key') ? window.atob(localStorage.getItem('key')) : ''
  data.products = JSON.stringify(data.products)
  data.photos = JSON.stringify(data.photos)
  data.token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
  data.user_id = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).id : ''
  data.stamp = stamp
  data.sign = md5(`${stamp}${data.token}${data.user_id}${key}`)
  return axios.post('/interface/addCreation', qs.stringify(data))
}

// 修改设计之家案例
export const updateCase = (data) => {
  const key = localStorage.getItem('key') ? window.atob(localStorage.getItem('key')) : ''
  data.products = JSON.stringify(data.products)
  data.photos = JSON.stringify(data.photos)
  data.token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
  data.user_id = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).id : ''
  data.stamp = stamp
  data.sign = md5(`${stamp}${data.token}${data.creation_id}${key}`)
  return axios.post('/interface/reviseWorks', qs.stringify(data))
}

// 新增小森有礼案例
export const addActivityCase = (data) => {
  const key = localStorage.getItem('key') ? window.atob(localStorage.getItem('key')) : ''
  if (data.amount_money) {
    data.amount_money = data.amount_money * 100
  }
  data.products = JSON.stringify(data.products)
  data.photos = JSON.stringify(data.photos)
  data.token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
  data.user_id = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).id : ''
  data.stamp = stamp
  data.sign = md5(`${stamp}${data.token}${data.user_id}${key}`)
  return axios.post('/interface/addCase', qs.stringify(data))
}

// 修改小森有礼案例
export const updateActivityCase = (data) => {
  if (data.amount_money ) {
    data.amount_money = Math.round(data.amount_money * 100)
  }
  data.products = JSON.stringify(data.products)
  data.photos = JSON.stringify(data.photos)
  const key = localStorage.getItem('key') ? window.atob(localStorage.getItem('key')) : ''
  data.case_id = data.id
  data.token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
  data.user_id = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).id : ''
  data.stamp = stamp
  data.sign = md5(`${stamp}${data.token}${data.user_id}${key}`)
  return axios.post('/interface/updateCase', qs.stringify(data))
}


// 查询推荐人手机号
export const searchChkMobile = (data) => {
  const token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
  const key = localStorage.getItem('key') ? window.atob(localStorage.getItem('key')) : ''
  data.user_id = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).id : ''
  data.sign = md5(`${stamp}${token}${data.mobile}${key}`)
  return axios.get('/interface/chkMobile', {
    params: {...data}
  })
}